export default "__VITE_ASSET__BaHWmdBK__"